// extracted by mini-css-extract-plugin
export var form = "contactForm-module--form--18pt_";